import React from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  const navbarStyles = {
    navbar: {
      background: "#003366",
      padding: "15px 0",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      borderRadius: "0",
    },
    brand: {
      padding: "0",
    },
    logo: {
      height: "45px",
      width: "auto",
    },
    navLink: {
      color: "#fff",
      fontSize: "1rem",
      fontWeight: "500",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      padding: "10px 20px",
      transition: "all 0.3s ease",
      borderBottom: "3px solid transparent",
    },
    navLinkActive: {
      borderBottom: "3px solid #fff",
      color: "#fff",
    },
    navLinkHover: {
      color: "#e0e0e0",
    },
    dropdownToggle: {
      background: "transparent",
      border: "none",
      color: "#fff",
      fontSize: "1rem",
      fontWeight: "500",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      padding: "10px 20px",
      borderRadius: "0",
    },
    dropdownMenu: {
      background: "#003366",
      border: "none",
      borderRadius: "0",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
      marginTop: "0",
      padding: "0",
    },
    dropdownItem: {
      color: "#fff",
      fontSize: "0.95rem",
      fontWeight: "500",
      letterSpacing: "0.5px",
      padding: "12px 25px",
      transition: "all 0.3s ease",
      borderRadius: "0",
      borderLeft: "3px solid transparent",
    },
    dropdownItemHover: {
      background: "#00264d",
      borderLeft: "3px solid #fff",
      color: "#fff",
    },
  };

  const customStyles = `
    .navbar {
      border-radius: 0 !important;
    }
    .navbar-toggler {
      border: 2px solid #fff !important;
      border-radius: 0 !important;
      padding: 8px 12px !important;
    }
    .navbar-toggler-icon {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
    }
    .nav-link:hover {
      color: #e0e0e0 !important;
    }
    .dropdown-menu {
      border-radius: 0 !important;
    }
    .dropdown-item:hover {
      background-color: #00264d !important;
      border-left: 3px solid #fff !important;
      color: #fff !important;
    }
    .dropdown-toggle::after {
      vertical-align: 0.15em !important;
      margin-left: 0.5em !important;
    }
  `;

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <style>{customStyles}</style>
      <Navbar expand="lg" style={navbarStyles.navbar}>
        <Container>
          <Navbar.Brand as={Link} to="/" style={navbarStyles.brand}>
            <img
              src={`${process.env.PUBLIC_URL}/OptLogo.svg`}
              alt="Optwise Group Logo"
              style={navbarStyles.logo}
              className="d-inline-block align-top"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                as={Link}
                to="/"
                style={{
                  ...navbarStyles.navLink,
                  ...(isActive("/") ? navbarStyles.navLinkActive : {}),
                }}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about"
                style={{
                  ...navbarStyles.navLink,
                  ...(isActive("/about") ? navbarStyles.navLinkActive : {}),
                }}
              >
                About
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact"
                style={{
                  ...navbarStyles.navLink,
                  ...(isActive("/contact") ? navbarStyles.navLinkActive : {}),
                }}
              >
                Contact
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/faq"
                style={{
                  ...navbarStyles.navLink,
                  ...(isActive("/faq") ? navbarStyles.navLinkActive : {}),
                }}
              >
                FAQ
              </Nav.Link>

              {/* Dropdown for "Insights" */}
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-insights"
                  style={navbarStyles.dropdownToggle}
                >
                  Insights
                </Dropdown.Toggle>
                <Dropdown.Menu style={navbarStyles.dropdownMenu}>
                  <Dropdown.Item
                    as={Link}
                    to="/tips"
                    style={navbarStyles.dropdownItem}
                  >
                    Tips
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to="/how-to-invest"
                    style={navbarStyles.dropdownItem}
                  >
                    How to Invest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navigation;
